export const translation_12_2_A = {
  en: {},
  ko: {
    v1: {
      typography_0: `꾸러미와 생각`,
      typography_1: `지난 시간에는 특정 상황이 발생했을 때 겪는 경험이 마치 하나의 거대한 꾸러미처럼 다가온다는 점을 알아보았습니다. 그리고 그 꾸러미를 촉발시킨 '상황'을 먼저 찾아내는 방법을 배웠습니다.`,
      typography_2: `마음은 어떤 사건을 마주하는 순간, 무수히 많은 생각과 감정, 신체 반응을 자동적으로 쏟아냅니다. 이 모든 것이 한데 뒤섞여 있으면 감정에 압도되기 쉽고 상황을 있는 그대로 바라보기 어려워집니다.`,
      typography_3: `이제 다음 단계로 나아가, 그 꾸러미를 세부 요소로 해체하는 연습을 할 차례입니다. 오늘은 여러 세부 요소 중 '생각'을 분리하는 연습을 해보겠습니다.`,

      typography_4: `핵심만 골라내기`,
      typography_5: `생각을 분리할 때 가장 먼저 기억해야 할 원칙은 '핵심적인 생각만 두세 문장으로 간추려 적기'입니다. 생각을 종이에 적어보라고 하면, 마치 일기를 쓰듯 마음속 이야기를 끝없이 털어놓거나 그 과정에서 생각을 정리하려는 시도를 하는 경우가 많습니다. 하지만 거리두기 훈련에서 생각을 분리하는 과정은 감정을 '배출'하거나 '정리하는' 시간이 결코 아닙니다.`,
      typography_6: `앞서 분리해 둔 바로 그 상황, 그 찰나의 순간에 가장 큰 영향을 미친 생각만 예리하게 추려내야 합니다. 눈을 감고 당시 상황으로 돌아가, 마음에 가장 먼저 스치고 지나갔던 강렬한 문장 두세 개만 포착해 보세요. 이렇게 핵심만 짚어내는 연습을 반복해야 생각에 매몰되지 않고 거리를 두는 기술을 자연스럽게 체화할 수 있습니다.`,
      typography_7: `다음 중 생각을 잘 알아차려 적은 형태는 무엇일까요?`,
      typography_quiz_incorrect: `활동지를 천천히 살펴본 뒤 다시 답해보세요.`,
      typography_8: `정답은 B입니다. A는 마음속 이야기를 두서 없이 적어내려간 형태입니다. B처럼 그 순간에 떠오른 핵심적인 생각만 두세 문장으로 짧게 추려내는 것이 올바른 분리 방식입니다.`,

      typography_9: `날것의 생각`,
      typography_10: `두 번째 원칙은 상황이 발생한 바로 그 '당시'에 들었던 생각만 있는 그대로 적는 것입니다. 보통 시간이 흐른 뒤 과거를 떠올리면 '그때 그렇게 하지 말았어야 했는데', '알고 보니 별일 아니었네'라며 새로운 생각을 덧붙이곤 합니다. 하지만 이런 사후적인 깨달음이나 후회는 사건 당시의 경험이 아니라, 현재 시점에서 새롭게 만들어진 생각일 뿐입니다.`,
      typography_11: `여기서 분리해내야 하는 것은 오직 그 특정 순간에 자동적으로 튀어오른 생각입니다. 시간의 흐름에 따라 변형되거나 다듬어지지 않은 최초의 반응을 찾아보세요. 당시의 찰나를 정지 화면처럼 멈춰놓고, 그 순간 머릿속을 스쳐 간 문장을 그대로 건져 올리는 연습이 필요합니다.`,
      typography_12: `친구가 약속에 늦었습니다. 당시에는 화가 났지만 지금은 이해가 되는 상태입니다. 이때 올바르게 적힌 생각은 무엇일까요?`,
      typography_13: `정답은 B입니다. A는 시간이 흐른 '지금' 드는 생각입니다. 사건이 발생한 바로 그 찰나에 들었던 가공되지 않은 생각인 B를 적는 것이 올바른 방식입니다.`,

      typography_14: `독백 형태`,
      typography_15: `마지막으로 생각을 기록할 때는 누군가에게 설명하는 말투가 아니라 혼잣말을 하는 '독백 형태'로 적어야 합니다.`,
      typography_16: `종종 타인을 의식해 다듬어진 표현을 쓰려는 경향이 있습니다. 하지만 사건이 벌어진 그 순간에는 결코 누군가에게 설명하듯 생각하지 않았을 것입니다.`,
      typography_17: `"또 망쳤네", "이건 말도 안 돼", "내가 할 수 있을까?"처럼 스스로에게 툭 던졌던 거친 말투를 그대로 살려보세요. 포장되기 전 날것 그대로의 생각을 관찰할 수 있어야 비로소 온전한 거리두기를 실천할 수 있습니다.`,
      typography_18: `다음 중 날것의 독백 형태로 가장 잘 적힌 것을 고르세요.`,
      typography_19: `정답은 B입니다. A는 누군가에게 설명하는 형태입니다. B처럼 혼잣말을 하는 독백 형태(~분명해, ~걸까?)로 적어야 그 순간의 감정과 생각을 정확히 포착할 수 있습니다.`,

      typography_20: `직접 해보기`,
      typography_21: `지금까지 살펴본 세 가지 원칙을 다시 한번 되새겨 보겠습니다. 이 원칙들을 지키며 내면의 목소리를 관찰하는 것만으로도 이미 생각의 소용돌이에서 한 걸음 빠져나오는 경험을 하실 수 있을 겁니다.`,
      typography_principle_1: `핵심만 두세 문장으로 포착하기`,
      typography_principle_2: `당시의 날것 그대로를 포착하기`,
      typography_principle_3: `설명이 아닌 독백 형태로 적기`,
      typography_22: `이제 직접 이 과정을 실습해 보겠습니다. 앞선 단계에서 명확하게 찾아낸 바로 그 상황을 다시 한번 적어보세요. 코치 선생님이 교정해주었다면, 올바르게 교정된 형태로 적어보세요.`,
      typography_23: `그리고 잠시 눈을 감고 그 순간으로 돌아가, 어떤 생각들이 자동적으로 스쳐 지나갔는지 가만히 관찰해 봅니다.`,
      typography_24: `자, 이제 그 찰나의 순간 마음속에 떠올랐던 생각을 알아차려 적어보세요.`,
      typography_25: `좋습니다. 코치 선생님이 확인 후 피드백 남겨주실 겁니다.`,
    },
  },
};
